import AbsolutePane from './_absolute-pane.js'
import FlexPane from './_flex-pane.js'
import Button from './_button.js'
import Text from './_text.js'
import Image from './_image.js'
import DotNotification from './_dot-notification.js'

export default {
  name: 'QuickLinks',
  values: {
    container: {
      configSet: AbsolutePane,
      configValues: {
        fixed: true,
        style: {
          width: '100%',
          height: '48px',
          bottom: '0px',
          left: '0px',
          zIndex: 700,
          padding: '0 0 env(safe-area-inset-bottom, 0px) 0',
        },
      },
    },
    linksContainer: {
      configSet: FlexPane,
      configValues: {
        nthSeparator: {
          '1': {
            style: {
              color: 'transparent',
              flexGrow: '1',
              flexBasis: '0px',
            },
          },
        },
        style: {
          alignItems: 'center',
        },
      },
    },
    linkButton: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            flexBasis: '0px',
            flexDirection: 'column',
            alignItems: 'center',
            minHeight: '100%',
          },
        },
      },
    },
    linkLabel: {
      configSet: Text,
      configValues: {
        style: {
          whiteSpace: 'nowrap',
        },
        container: {
          flexGrow: '0',
        },
      },
    },
    linkIcon: {
      configSet: Image,
      configValues: {
        style: {
          minWidth: '16px',
          minHeight: '16px',
        },
      },
    },
    isDotNotificationVisible: false,
    dotNotification: {
      configSet: DotNotification,
      configValues: {},
    },
    links: undefined,
  },
  meta: {
    extendable: false,
  },
}
